import type { CreateOrder, Order } from '../order/order.interface';
import { ORDER_STATUS, TRANSPORT_TYPE } from '../order/order.interface';
import { SITE_TYPE } from '../site/site.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class OrderFactory extends ObjectFactory<Order> {
  protected getDefaults(): Order {
    return {
      ...baseDocumentFactory.build(),
      customer: {
        id: 'aaaaaaaaaaaaaaaaaaaaaaaa',
        firstName: 'John',
        lastName: 'Doe',
        phone: { dialCode: '+33', number: '612345678' },
      },
      delivery: {
        site: { code: 'SITE01', color: '#000', id: 'site-1', name: 'Warehouse', type: SITE_TYPE.WAREHOUSE },
      },
      orderType: { code: 'STD', id: 'ot-1', label: 'Standard' },
      pickup: {
        durationTime: 15,
        site: { code: 'PICKUP01', color: '#fff', id: 'site-2', name: 'Pickup Point', type: SITE_TYPE.SHOP },
      },
      referenceNumber: 'REF-001',
      shipper: { id: 'aaaaaaaaaaaaaaaaaaaaaaaa', code: 'SHIPPER01', logo: 'logo.png', name: 'Shipper' },
      siteId: 'site-1',
      spaceId: 'space-1',
      status: ORDER_STATUS.NEW,
      transportType: TRANSPORT_TYPE.DELIVERY,
    };
  }

  /** Build a CreateOrder body (no base document fields). */
  buildCreate(overrides: Partial<CreateOrder> = {}): CreateOrder {
    return {
      customer: { firstName: 'John', lastName: 'Doe', phone: { dialCode: '+33', number: '612345678' } },
      delivery: { durationTime: 30, siteCode: 'DEL01' },
      orderTypeCode: 'STD',
      pickup: { durationTime: 15, siteCode: 'PICKUP01' },
      referenceNumber: 'REF-001',
      shipperCode: 'SHIPPER01',
      siteCode: 'SITE01',
      transportType: TRANSPORT_TYPE.DELIVERY,
      ...overrides,
    };
  }
}

export const orderFactory = new OrderFactory();
